/**
 * Custom Footer — smooth-scrolls the page back to top when the
 * back-to-top button is clicked.
 */
(function () {
  function initFooter(root) {
    if (!root || root.dataset.footerInitialized === 'true') return;
    root.dataset.footerInitialized = 'true';

    var backToTopBtn = root.querySelector('[data-back-to-top]');
    if (!backToTopBtn) return;

    backToTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-custom-footer]');
    if (root) initFooter(root);
  });
})();